import { createContext, useContext, useState, type ReactNode } from 'react'
import { apiClient } from '../api/client'

interface AuthContextValue {
  isAuthenticated: boolean
  token: string | null
  login: (newToken: string) => void
  logout: () => void
}

const AuthContext = createContext<AuthContextValue | null>(null)

/**
 * 認証状態プロバイダー
 *
 * アプリ全体で認証状態を共有するためのProvider。
 * localStorageからトークンを復元し、ログイン/ログアウト機能を提供。
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  const [token, setToken] = useState<string | null>(
    localStorage.getItem('noah_token')
  )

  const login = (newToken: string) => {
    apiClient.setToken(newToken)
    setToken(newToken)
  }

  const logout = () => {
    apiClient.clearToken()
    setToken(null)
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated: !!token, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

/**
 * 認証状態管理フック
 *
 * AuthProvider内で使用し、共有された認証状態にアクセスする。
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
